// extracted by mini-css-extract-plugin
export var addToCartButton = "_pk-b";
export var arrowButtonContainer = "_pk-9";
export var arrowButtonIcon = "_pk-a";
export var carouselArrowButton = "_pk-6";
export var carouselElementContainer = "_pk-1";
export var left = "_pk-7";
export var productDisplayCarouselContainer = "_pk-0";
export var productTileContainer = "_pk-2";
export var productTileImage = "_pk-4";
export var productTileImageContainer = "_pk-3";
export var productTileTitle = "_pk-5";
export var right = "_pk-8";
export var sliderOverflow = "_pk-c";